import { useState, useEffect } from 'preact/hooks';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth || 0,
    height: window.innerHeight || 0,
  });
  const [initialized, setInitialized] = useState(false);

  const handleSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
    setInitialized(true);

    return () => window.removeEventListener('resize', handleSize);
  }, []);

  return {
    ...windowSize,
    isMobile: windowSize.width < 768,
    isTablet: windowSize.width >= 768 && windowSize.width < 1024,
    initialized,
  };
}

export default useWindowSize;
